import { cn } from '@/utils';
import { legalNotices } from '@/data/legal';

interface BrandLogoProps {
  variant?: 'light' | 'dark';
  className?: string;
}

/** TODO: REEMPLAZAR CON LOGOTIPO DEFINITIVO */
export function BrandLogo({ variant = 'dark', className }: BrandLogoProps) {
  return (
    <div className={cn('flex flex-col leading-none', className)} aria-label="UGA Bienes Raíces">
      <span
        className={cn(
          'font-heading text-2xl font-bold tracking-widest',
          variant === 'light' ? 'text-semantic-text-on-dark' : 'text-charcoal',
        )}
      >
        UGA
      </span>
      <span
        className={cn(
          'text-[0.6rem] font-medium uppercase tracking-[0.25em]',
          variant === 'light' ? 'text-gold-light' : 'text-gold-dark',
        )}
      >
        Bienes Raíces
      </span>
      <span className="sr-only">{legalNotices.logoTodo}</span>
    </div>
  );
}
